/**
 * This module just wraps the "global" runtime variables injected via the `public/runtime.js` script.
 * This is necessary to allow us to provide configuration to the client at deploy time, as opposed
 * to when we run `yarn build`.
 */

 
// @ts-ignore
const RuntimeEnvironment = window.RuntimeEnvironment || {
  platform: {
    host: "http://localhost.localdomain:3333"
  },
  yWebsocket: {
    host: 'ws://localhost:1234',
    http: 'http://localhost:1234'
  },
  platformUser: {
    email: "",
    password: ""
  },
  defaultAvatar: "/images/default_avatar.png",
	tiptapCloud: {
		appId: "",
		conversionAppId: "",
	}
};
export default RuntimeEnvironment;
